<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        사용자
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">관리</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">사용자</a>
        </li>
      </ul>
    </div>
    <div>
      <b-row>
        <b-col lg="12" xl="12">
          <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" >
            <b-tab title="정보">
              <b-card>
                <div class="d-flex flex-wrap align-items-center">
                  <div class="title mr-auto">
                    사용자 정보
                  </div>
                  <div class="col-xl-1 col-md-12  d-flex align-self-center">
                    <span class="pull-right" v-if="!add && model.created_at">등록일 ({{model.created_at | sdate}} @ {{model.last_addr || '-'}})</span>
                  </div>
                </div>
                <hr>
                <div class="row mb-2">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="Allow_login" label-for="ph_use">
                      로그인 허용
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox disabled" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock" />
                      <div class="checkbox-animate disabled">
                        <span class="checkbox-off">OFF</span>
                        <span class="checkbox-on">ON</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="Email_verified" label-for="ph_active">
                      확인된 이메일
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox disabled" name="Email_verified" id="Email_verified" v-model="model.is_verified" :disabled="lock" />
                      <div class="checkbox-animate disabled">
                        <span class="checkbox-off">OFF</span>
                        <span class="checkbox-on">ON</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label">
                      마지막 접속일
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.id">
                    <b-form-input type="text" :value="model.last_visit | datetime" plaintext></b-form-input>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center" v-else>
                    -
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_group">
                      권한
                      <span class="text-danger ml-1">*</span>
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <select class="form-control" v-if="!lock" label="name" v-model="model.permissions">
                      <option v-for="(item, index) in codes.permissions_user" :key="index" :value="item">{{item}}</option>
                    </select>
                    <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="사용자명은 이메일 주소로 하는것으로 권합니다.">사용자명(아이디)<span class="text-danger ml-1">*</span></label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input @change="auto_set_nickname($event, model.username)" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <label class="col-form-label" for="ph_nickname">이름<span class="text-danger ml-1">*</span></label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
                  </div>
                </div>
                <div class="row mb-2" v-show="add || !lock">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <b-form-group>
                      <label class="col-form-label" for="ph_pass">{{add ? '' : '새'}} 비밀번호<span class="text-danger ml-1">*</span></label>
                    </b-form-group>
                  </div>
                  <div class="col-xl-4 col-md-12">
                    <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
                    <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> 숫자 </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> 대문자 </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> 소문자 </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> 특수 문자 </b-badge>
                    <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                      최소 길이 : 10 글자
                    </b-badge>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.new_password">
                    <b-form-group>
                      <label class="col-form-label" for="ph_pass2">비밀번호 확인<span class="text-danger ml-1">*</span></label>
                    </b-form-group>
                  </div>
                  <div class="col-xl-4 col-md-12" v-if="model.new_password">
                    <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat"  :plaintext="lock"></b-form-input>
                  </div>
                </div>
                <b-badge class="mt-3" variant="warning"> 안내 </b-badge>
                : 비밀번호를 공란으로 설정한 경우 48시간 동안 비밀번호 재설정 링크를 보내주세요.
                <div class="row mb-4 mt-3">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <b-form-group>
                      <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="단일 IP 또는 네트워크 범위를 입력하세요., etc) 192.168.0.100, 192.168.0.0/24 ">허용된 IP 목록</label>
                    </b-form-group>
                  </div>
                  <div class="col-xl-10 col-md-12">
                    <!-- <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea> -->
                    <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :disabled="lock"></b-form-textarea>
                  </div>
                </div>
                <b-button v-if="!lock" size="sm" class="btn btn-add" @click="save"> 저장 </b-button>
                <b-button v-else size="sm" variant="warning" @click="lock = false" :disabled="model.is_del">
                  {{ model.is_del ? '이미 삭제된 사용자입니다.' : '편집'}}
                </b-button>
                <b-button v-if="!lock" size="sm" variant="secondary" @click="cancel"> 취소 </b-button>
                <b-button size="sm" variant="danger" @click="confirm = true;" v-if="model.id && !model.is_del && lock" :disabled="model.is_del"> 삭제 </b-button>
                <b-button size="sm" class="btn btn-cancel" @click="send_password_reset_mail" v-if="model.id && !model.is_del" :disabled="model.is_del"> 비밀번호 재설정 메일 보내기 </b-button>
                <b-button size="sm" class="btn btn-addition" @click="send_ip_reset_mail" v-if="model.id && !model.is_del" :disabled="model.is_del"> IP ACL 재설정 메일 보내기 </b-button>
                <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
                </b-card>
                <b-card>
                <!-- start group info -->
                <div class="d-flex flex-wrap align-items-center">
                  <div v-if="!model.group.id" class="title mr-auto">
                    그룹 정보 등록<span class="text-danger ml-1">*</span>
                  </div>
                  <div v-else class="title mr-auto">
                    그룹 정보<span class="text-danger ml-1">*</span>
                  </div>
                </div>
                <hr>
                <div class="row mb-2">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" >
                    <label  class="col-form-label" for="ph_name">그룹 이름</label>
                  </div>
                  <div v-if="!model.group.groupname" class="col-xl-2 col-md-12">
                    <b-button id="ph_search_group" :variant="model.group.groupname ? 'primary' : 'add'" @click="chainGroup = true">그룹 선택</b-button>
                  </div>
                  <div v-else class="col-xl-4 col-md-12">
                    <b-form-group>
                      <b-form-input type="text" v-if="lock" v-model="model.group.groupname" plaintext></b-form-input>
                      <b-form-input @keydown.enter="refresh" v-else type="text" v-model="model.group.groupname" :disabled="true"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.group.id">
                    <label class="col-form-label" label="Verified" label-for="ph_use">
                      로그인 허용
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.group.id">
                    <div class="checkbox-switch">
                      <input type="checkbox" class="input-checkbox disabled" name="Email_verified" id="Email_verified" v-model="model.group.is_verified" :disabled="true" />
                      <div class="checkbox-animate disabled">
                        <span class="checkbox-off">OFF</span>
                        <span class="checkbox-on">ON</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-2"  v-if="model.group.id">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_service" v-b-tooltip.hover title="서비스">서비스</label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <v-select v-if="add" :disabled="true" label="name" v-model="model.group.service" :options="codes.service_name"></v-select>
                    <h4 v-else>
                      <b-badge  :variant="model.group.service == 'Basic' ? 'info' : 'success'"> {{model.group.service}} </b-badge>
                    </h4>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" label="Member's" label-for="ph_count">
                      회원 수
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    {{model.group.count || 0}}
                  </div>
                </div>
                <div class="row mb-2"  v-if="model.group.id">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_email">
                      이메일
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input type="text" v-if="lock" v-model="model.group.email" plaintext></b-form-input>
                  </div>
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" label="contact" label-for="ph_contact">
                      컨택트
                    </label>
                  </div>
                  <div class="col-xl-4 col-md-12  d-flex align-self-center">
                    <b-form-input type="text" id="ph_contact" v-if="lock" v-model="model.group.contact" plaintext></b-form-input>
                  </div>
                </div>
                <div class="row mb-2"  v-if="model.group.id">
                  <div class="col-xl-2 col-md-12 d-flex align-self-center">
                    <label class="col-form-label" for="ph_address">
                      주소
                    </label>
                  </div>
                  <div class="col-xl-10 col-md-12  d-flex align-self-center">
                    <b-form-input md=12 type="text" v-if="lock" id="ph_address" v-model="model.group.address" plaintext></b-form-input>
                  </div>
                </div>
                <div class="d-flex flex-wrap align-items-center mt-5">
                  <div class="title mr-auto"  v-if="model.group.id">
                    지역
                  </div>
                </div>
                <hr>
                <b-row v-if="model.group.id">
                  <b-col md="4">
                    <b-form-group class="col-form-label" label="국가" label-for="ph_country">
                      <select class="form-control" label="name" v-model="region.country" :disabled="true">
                        <option v-for="(item, index) in codes.country" :key="index" :value="item">{{item.name}}</option>
                      </select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group class="col-form-label" label="언어" label-for="ph_language">
                      <select class="form-control" label="name" v-model="region.language" :disabled="true">
                        <option v-for="(item, index) in codes.language" :key="index" :value="item">{{item.name}}</option>
                      </select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group class="col-form-label" label="시간대" label-for="ph_timezone">
                      <select class="form-control" label="name" v-model="region.timezone" :disabled="true">
                        <option v-for="(item, index) in codes.timezone" :key="index" :value="item">{{ item.name }}</option>
                      </select>
                    </b-form-group>
                  </b-col>
                </b-row>
                  <!-- end group info -->
                <div>
                  <div class="d-flex flex-wrap">
                    <div class="mr-auto">
                    </div>
                    <div class="mr-2">
                      <b-button v-if="!add" size="sm" class="pull-right mx-1" variant="primary" @click="groupList"> 그룹 상세 보기 </b-button>
                    </div>
                  </div>
                </div>
              </b-card>
            </b-tab>
            <b-tab title="로그인 로그" border-variant="primary" :disabled="!model.id">
              <!-- 해당 사용자의 로그인 목록 -->
              <log-Login-List v-if="model.id" :user="model"></log-Login-List>
            </b-tab>
            <b-tab title="작업 로그" border-variant="primary" :disabled="!model.id">
              <!-- 해당 사용자의 액션 목록 -->
              <log-Action-List v-if="model.id" :user="model"></log-Action-List>
            </b-tab>

            <b-modal title="삭제 안내"  class="modal-danger" header-bg-variant="danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" ok-title="확인" cancel-variant="outline-dark" cancel-title="취소">
              해당 사용자를 삭제할까요?
            </b-modal>
            <!-- start connect group modal -->
            <b-modal title="그룹 선택" size="lg" v-model="chainGroup" @ok="chainGroup = false" ok-variant="primary" ok-title="확인" ok-only>
              <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
              <!-- <b-button class="mt-3 float-right" @click="chainGroup = false" variant="info">확인</b-button> -->
            </b-modal>
            <!-- end connect group modal -->
          </b-tabs>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>